// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-drawer .v-list__tile{height:38px}.nav-drawer .v-list-item__title{color:#fff}.nav-drawer .v-toolbar__content{padding-top:0!important}", ""]);
// Exports
module.exports = exports;
